// Claim ROLE presentation — the rhetorical job a claim plays in the argument.
//
// The backend `claim_type` enum is unchanged (thesis/supporting/counter/
// synthesis/gap). These are DISPLAY labels only, chosen to read as nouns that
// don't collide with the link RELATION verbs (supports/challenges/qualifies):
// "supporting" → "Reason", "counter" → "Objection". So a user reads
// "this Reason supports the Thesis" — role-noun + relation-verb, no shared stem.
//
// `gap` is intentionally NOT a selectable role. It's a separate state — an
// "open question" / unaddressed hole (AI-seeded from Field Debate, or manually
// flagged) — and is excluded from completeness scoring server-side. The UI
// surfaces it via a dedicated control, never the role picker.

export const ROLE_LABELS: Record<string, string> = {
  thesis: "Thesis",
  supporting: "Reason",
  counter: "Objection",
  synthesis: "Synthesis",
  gap: "Open question",
};

export function roleLabel(claimType: string): string {
  return ROLE_LABELS[claimType] ?? claimType;
}

// The roles a user can pick from the Role selector (gap excluded by design).
export const SELECTABLE_ROLES: { value: string; label: string }[] = [
  { value: "thesis", label: ROLE_LABELS.thesis },
  { value: "supporting", label: ROLE_LABELS.supporting },
  { value: "counter", label: ROLE_LABELS.counter },
  { value: "synthesis", label: ROLE_LABELS.synthesis },
];
